module.exports = __webpack_public_path__ + "img/box_bonus_last_disable.95b281c4.png";